import React from 'react';
import { Typography, CircularProgress } from '@mui/material';

export const LoadingState: React.FC = () => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    padding: '40px 16px',
    minHeight: '200px'
  }}>
    <CircularProgress size={24} style={{ marginRight: '12px' }} />
    <Typography variant="body1" color="text.secondary">
      กำลังโหลดตัวกรอง...
    </Typography>
  </div>
); 